<template>
  <div class="col backgroundForm">
    <div class="col col-md-6 offset-md-3">
        <div class="alert alert-success" role="alert">
            <h4 class="alert-heading">Resumen de Naves y Artefactos Navales</h4>
            <p>Seleccione la capitania y obtenga el resumen de Naves</p>
            <hr>
        </div>    
    </div>
     <div class="form-group col-12 col-md-4 offset-md-4">
        <div v-if="cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'">
            <label for="capitania boss" >Seleccion Capitania</label>

            <select name="captain_download" class="form-control" id="captain_download" v-model="port_select" @change="mClearList">
                <option :value="{id:0}">TODAS LAS CAPITANIAS</option>
                <option v-for="port in ports_ships" :value="port" :key="port.id">{{ port.name_port }}</option>
            </select>
        </div>

        <div v-else>
            <div class="alert alert-success">{{ cDtsUser.name_port }}</div>
        </div>        
    </div>


    <button class="btn btn-outline-primary col-12 col-md-3 offset-md-3" @click="mCallShips">
        <font-awesome-icon icon="list" size="2x" /> Resumen Naves o Artefactos Navales
    </button>
    <button class="btn btn-outline-success col-12 col-md-3" @click="mCallListShips">
        <font-awesome-icon icon="file-excel" size="2x" /> Listado Naves
    </button>
    <br><br>
    <div class="table-responsive col-12 col-md-6 offset-md-3" v-if="list_ship.length > 0">

        <table class="table table-sm">
            <thead>
                <tr><th colspan="3">{{ port_select.id > 0 ? port_select.name_port : 'TODAS LAS CAPITANIAS'}}</th></tr>
                <tr>
                    <th>#</th>
                    <th>Tipo</th>
                    <th>Cantidad</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ls, index) in list_ship" :key="ls.idS">
                    <td>{{ index + 1 }}</td>
                    <td>{{ ls.tShip }}</td>
                    <td>{{ ls.quantity }}</td>
                </tr>
                <tr>
                    <td colspan="2"><b>TOTAL</b></td>
                    <td>{{ total_ships }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <modal-loading :id-modal="idModalLoad" :title="titleLoad" :status-send="sendRequest"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';
const qs = require('qs');

export default {
    data(){
        return{
            idModalLoad:'loadShips',
            titleLoad:'Solicitando',
            sendRequest:true,
            ports_ships:[],
            port_select:{id:-1},
            list_ship:[],
            total_ships:0,
            urlR:'pdfListShip'
        }
    },
    mounted(){
        this.chargeInit();
    },
    methods:{
        mCallListShips(){
            // aqui configurar todo la url e id que iran
            if(this.cDtsUser.roleAssign === 'OPERADOR CAPITANIA'){
                this.port_select.id=this.cDtsUser.portId;
                this.port_select.name_port=this.cDtsUser.name_port;
            }
            console.log(this.port_select.id)
            if(this.port_select.id >= 0){
                let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                // let url_report=btoa(`pdfOrdopI/${id}`)
                let route = this.$router.resolve({path: `/report/${url_report}`});            
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.info(`Seleccione una opcion`, 'Error');
            }
        
        },
        mClearList(){
            this.list_ship=[];
        },
        async mCallShips(){
            if(this.cDtsUser.roleAssign === 'OPERADOR CAPITANIA'){
                this.port_select.id=this.cDtsUser.portId;
                this.port_select.name_port=this.cDtsUser.name_port;
            }
            console.log(this.port_select.id)
            if(this.port_select.id >= 0){
                // aqui enviamos la solicitud al servidor
                
                let dts=await axios.get(`getResumeShips/${this.port_select.id}?api_token=${Vue.auth.getToken()}`);
                // console.log(dts);
                if(dts.data.length > 0){
                    this.list_ship=[];
                    this.total_ships=0;
                    let dtstemp=dts.data;
                    dtstemp.forEach(el => {
                        let at={
                            idS:`${el.idS}${el.portR}`,
                            tShip:el.tShip,
                            quantity:el.quantity
                        }
                        this.total_ships+=parseInt(el.quantity);
                        this.list_ship.push(at);
                    });
                } else{
                    toastr.info('No existen registros en estas capitanias', 'Informacion');
                }
            }else{
                toastr.warning('Seleccione una opcion', 'Advertencia');
            }
            
            // console.log('enviando al servidor');
        },
        async chargeInit(){
            this.mShowModal(this.idModalLoad);
            
            // const ports = await axios.get(`getPorts`);        
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        
            this.ports_ships = ports.data;
            
            setTimeout(()=>{
                this.mHideModal(this.idModalLoad);
            },1000)
        },
        mShowModal(e){
            $(`#${e}`).modal('show');
        },
        mHideModal(e){
            $(`#${e}`).modal('hide');
        },
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/matriculacion/ResumeShips.vue